import { render } from "./MethodTooltip.vue?vue&type=template&id=1c1b34cd&lang=pug"
import script from "./MethodTooltip.vue?vue&type=script&lang=js"
export * from "./MethodTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__